module.exports = __webpack_public_path__ + "img/zara.68ee9615.jpg";